import { render, staticRenderFns } from "./shared-models.html?vue&type=template&id=6b0b6480&scoped=true&external"
import script from "./shared-models.js?vue&type=script&lang=js&external"
export * from "./shared-models.js?vue&type=script&lang=js&external"
import style0 from "./shared-models.scss?vue&type=style&index=0&id=6b0b6480&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b6480",
  null
  
)

export default component.exports